const Strings = {
  SIGN_OUT: 'Logga ut',
  SIGN_OUT_HEADER: 'Är du säker på att du vill logga ut?',
  NO: 'Nej',
  YES: 'Ja',
  LAUNDRY_INTRO: 'Här kan du ändra tvättinställningar och se tvättbokningar.',
  BOOKINGS_INTRO:
    'Här kan du skapa nya bokningssystem för till exempel bastun eller grillen.',
  FEED_INTRO: 'Här kan du lägga upp ett nytt inlägg i nyhetsflödet.',
  INFO_INTRO:
    'Här redigerar du viktiga telefonnummer och adresser medlemmarna kan se.'
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/strings.js